import React from 'react';
import { Box } from '@mantine/core';
import { PAGE_CONTENT_GUTTER_PX, PAGE_CONTENT_MAX_WIDTH_PX } from './pageLayoutConstants';

/**
 * Limite la largeur du bloc au viewport « desktop » tout en restant fluide sur mobile.
 * Utilisé pour les blocs Puck racine (sauf heros / bandeaux pleine largeur) et pour
 * aligner header / footer sur la même largeur max que le contenu.
 */
const PageContentConstraint = ({
  children, style, paddingX = PAGE_CONTENT_GUTTER_PX, ...boxProps
}) => (
  <Box
    component="div"
    w="100%"
    mx="auto"
    px={paddingX}
    /* Marqueur stable : neutralisé (display:contents) dans les colonnes de
       section, qui contraignent déjà la largeur — cf. ProposalSection.module.css */
    data-page-constraint=""
    style={{
      maxWidth: `${PAGE_CONTENT_MAX_WIDTH_PX}px`,
      boxSizing: 'border-box',
      ...style,
    }}
    {...boxProps}
  >
    {children}
  </Box>
);

export default PageContentConstraint;
